import React from 'react';

/** Lazy ClientComputedPdfPreview (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedPdfPreview = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-pdf-preview' */
            './ClientComputedPdfPreview'
        ),
);
